import { extend, pick, isString } from 'lodash';
import EventEmitter from '../../../utility/event-emitter';
import { PEOPLE_TYPES } from '../../../store/features/realtime/presence';
export class PnPerson extends EventEmitter {
    constructor(props) {
        super();
        this.activeVideo = false;
        this.currentUserId = props.currentUserId;
        this.uuid = props.uuid;
        this.state = props.state;
        this.userPicture = props.userPicture;
        this.type = props.type;
        this.roomId = props.roomId;
        this.member = props.member;
        this.isUndetermined = Boolean(props.isUndetermined);
    }
    changeState(data) {
        const oldStatus = this.state.status;
        extend(this.state, data);
        if (data.status && data.status !== oldStatus) {
            this.emit('stateUpdate:status', data.status);
        }
    }
    isEqualTo(person) {
        return this.uuid === person.uuid;
    }
    startVideo() {
        this.activeVideo = true;
        if (this.isOnMobileApp()) {
            this.changeState({ callInitiator: this.currentUserId });
        }
    }
    hasBadConnection() {
        return (Boolean(this.state.connection) &&
            ['unstable', 'poor'].includes(this.state.connection.level));
    }
    endVideo() {
        this.activeVideo = false;
        if (this.isOnMobileApp()) {
            this.changeState({ callInitiator: this.currentUserId });
        }
    }
    setUserPicture(userPicture) {
        this.userPicture = userPicture;
    }
    /**
     * @deprecated We do not support mobile app anymore.
     * @TODO       https://doxyme.atlassian.net/browse/CS-8575
     */
    isOnMobileApp() {
        // @TODO remove
        return false;
    }
    canShareScreen() {
        if (this.isOnMobileApp()) {
            return false;
        }
        if (this.isOnMobileBrowser()) {
            return false;
        }
        return this.state.system.supportsScreensharing;
    }
    getSystemInfo() {
        return Object.values(pick(this.state.system, [
            'os',
            'osversion',
            'browser',
            'browserVersion',
            'platform',
        ])).join('--');
    }
    isOnMobileBrowser() {
        return Boolean(this.state.mobileBrowser);
    }
    isPatient() {
        return this.type === PEOPLE_TYPES.patient;
    }
    isDoctor() {
        return this.type === PEOPLE_TYPES.doctor;
    }
    supportsRoutedSessions() {
        const system = this.state.system;
        return system?.browser === 'safari' ? system.browserVersion > 11 : true;
    }
    isUsingVideoProvider(provider) {
        return this.getVideoProviderUsed() === provider;
    }
    hasEhrId() {
        return Boolean(this.state.pid);
    }
    getUserId() {
        return this.member?.identity.userId;
    }
    isV2() {
        return this.state.checkedInV2WaitingRoom ?? false;
    }
    getVideoProviderUsed() {
        return isString(this.state.vcp) && this.state.vcp.length > 0
            ? this.state.vcp
            : 'tokbox';
    }
}
